// Maintenance detection for a page that is already open when a deploy starts.
//
// During a deploy nginx answers EVERY request with the maintenance page — including the app's
// /api calls, and with status 200. A fresh visit shows that page, which is right; but an app
// already running in the browser would try to read that HTML as data, crash, and go white.
// So the API layer reports "this looks like maintenance" here, and MaintenanceGate swaps the
// app for an "updating" screen that reloads by itself once the server answers normally.

let active = false;
const listeners = new Set();

export const isMaintenance = () => active;

export function signalMaintenance() {
    if (active) return;
    active = true;
    listeners.forEach(fn => fn(true));
}

export function onMaintenanceChange(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}

// Does this axios response/error mean the server is being updated (not a normal API error)?
export function looksLikeMaintenance({ response, error }) {
    if (response) {
        // An /api call answered with a web page instead of data = the maintenance page
        const type = String(response.headers?.['content-type'] || '');
        return type.includes('text/html');
    }
    if (error) {
        if (error.response) return [502, 503, 504].includes(error.response.status);
        // No answer at all while the phone is online: the server is down for the update.
        // Offline (no signal on the round) is NOT maintenance — leave that to the screen's own errors.
        return typeof navigator === 'undefined' || navigator.onLine !== false;
    }
    return false;
}
